import React, { Component } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import { Spinner } from 'react-activity';
import Loader from './Loader';
import DropdownContainer from './DropdownContainer';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: '#181b22',
        border: '1px solid #34373e',
        color: 'white',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? '#f4f4f4' : '#181b22',
        color: state.isDisabled ? '' : 'white',
        ':hover': {
            backgroundColor: state.isDisabled ? 'none' : '#543cc2',
            color: state.isDisabled ? 'none' : 'white',
            opacity: state.isDisabled ? provided.opacity : 1,
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'white',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#543cc2', // Background color of the selected badges
        borderRadius: '4px', // Optional: Adjust border radius for rounded corners
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white', // Text color of the selected badges
        padding: '2px 6px', // Optional: Adjust padding for better appearance
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: '#543cc2',
            color: 'white',
            cursor: 'pointer',
        },
    }),
    input: (provided) => ({
        ...provided,
        color: 'white',
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#181b22',
        color: 'white',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: 'white',
        backgroundColor: '#181b22',
        textAlign: 'center',
    }),
};

class AddRemoveStudent extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                className={'modal-add-student-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-white">
                                {this.props.t('addOrRemoveTeamMembers')}
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="divide-y divide-slate-200">
                            <div className="py-4">
                                {this.props.isBroadcast ? (
                                    <>
                                        {this.props.isStudentLoading ? (
                                            <Loader />
                                        ) : (
                                            <DropdownContainer
                                                data={this.props.studentTreeViewList}
                                                onChange={this.props.handleLevelChange}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <Select
                                        isLoading={this.props.isStudentLoading}
                                        ref={(r) => (this.selectRef = r)}
                                        className="block rounded text-secondary text-md bg-dateselect addORremoveStudents"
                                        name="students"
                                        onChange={(event) => {
                                            this.props.onChange(event);
                                        }}
                                        options={this.props.options}
                                        isMulti={true}
                                        styles={customSelectStyles}
                                        isSearchable={true}
                                        value={this.props.editSessionStudents}
                                        onKeyDown={(event) => {
                                            const key = event.key;
                                            const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                            if (
                                                !allowedCharacters.test(key) ||
                                                (event.keyCode === 32 &&
                                                    !this.selectRef.state.inputValue)
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                        isOptionDisabled={(option) => {
                                            return (
                                                this.props.editSessionStudents &&
                                                this.props.editSessionStudents.length >= 30 &&
                                                !this.props.editSessionStudents.includes(option)
                                            );
                                        }}
                                        noOptionsMessage={() => this.props.t('noOptions')}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white bg-black rounded-lg"
                                onClick={() => this.props.closeModal()}
                            >
                                {this.props.t('cancel')}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white rounded-lg bg-UIprimary"
                                onClick={() => this.props.saveStudents()}
                                disabled={this.props.isSaveStudent}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.isSaveStudent ? <Spinner color="#FFF" /> : this.props.t('save')}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const ConnectedAddRemoveStudent = withLanguage(AddRemoveStudent);

export default (props) => (
    <LanguageProvider>
        <ConnectedAddRemoveStudent {...props} />
    </LanguageProvider>
);
